<template>
  <div class="detailed-cell">
    <!-- 日期切换 -->
    <div class="bg-w">
      <span @click="onBeforeDateClick" class="usable">{{ "前一" + modelName }}</span>
      <span @click="onDateSpanClick" class="usable">{{ setDateOkText(datePickerValue) }}</span>
      <span @click="onNextDateClick" :class="nextDateClassName">{{ "后一" + modelName }}</span>
    </div>
    <!-- 交易类型列表 -->
    <div class="tips-bottom bg-w">
      <!-- 佣金 达标奖励 服务费代收-->
      <div class="tips-bottom-info" v-for="(item, index) in dataList" :key="index">
        <div>
          <span>{{ item.balance }}</span>
        </div>
        <div>
          <span>{{ item.accountName }}</span>
        </div>
      </div>
    </div>
    <mt-datetime-picker ref="datePicker" type="date" v-model="pickerValue" :endDate="new Date()" year-format="{value} 年" month-format="{value} 月" date-format="{value} 日" @confirm="onDatePickerConfirm">
    </mt-datetime-picker>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import { CusToast } from '@/utils/CustomToast';
import { formatDate, formatDateYm } from '@/utils/utils';
import { SucceedHandle, NotSucceedHandle } from '@/api/handle';
import { GetProfit } from '@/api/reward';

export default {
  name: 'DetailedTips',
  props: ['mark'],
  data() {
    return {
      dataList: [],
      modelName: '天',
      nextDateClassName: 'usable',
      pickerValue: null,
      datePickerValue: null,
      dataList_show: [
        { balance: '12000.00', accountName: '佣金(元)' },
        { balance: '11100.00', accountName: '达标奖励(元)' },
        { balance: '99990.00', accountName: '服务费代收(元)' },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      // 设置默认日期为当前日期
      this.datePickerValue = new Date();
      // 设置时间间隔
      this.modelName = this.mark === 1 ? '天' : '月';
      // 设置下一天/下一月按钮样式
      this.setNextDateClassName();
      // 加载数据
      this.initData();
    });
  },
  computed: {
    currentSelectedDate() {
      const yyyy = this.datePickerValue.getFullYear();
      const MM = String(this.datePickerValue.getMonth() + 1).padStart(2, '0');
      const dd = String(this.datePickerValue.getDate()).padStart(2, '0');
      return yyyy + '-' + MM + '-' + dd + ' 00:00:00';
    },
    prevPageSelectedFlag() {
      return parseInt(this.mark);
    },
  },
  methods: {
    getProfit() {
      Indicator.open();
      GetProfit({
        date: this.currentSelectedDate,
        flag: this.prevPageSelectedFlag,
      })
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.dataList = res.rows;
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },

    initData() {
      // 判断接口开关
      switch (this.$store.state.INTERFACE_ON_OFF) {
        case 'on':
          this.getProfit();
          break;
        case 'off':
          this.dataList = this.dataList_show;
          break;
      }
    },

    setDateOkText(val) {
      if (val) {
        if (this.mark === 1) return val.getFullYear() + '年' + (val.getMonth() + 1) + '月' + val.getDate() + '日';
        else if (this.mark === 2) return val.getFullYear() + '年' + (val.getMonth() + 1) + '月';
      }
      return '';
    },

    openDatePicker() {
      this.pickerValue = this.datePickerValue;
      this.$refs.datePicker.open();
      if (this.mark === 2) {
        this.$refs.datePicker.$el.getElementsByClassName('picker-slot')[2].style.display = 'none';
      }
    },

    onDateSpanClick() {
      this.openDatePicker();
    },

    onDatePickerConfirm(val) {
      this.datePickerValue = val;
      this.setNextDateClassName();
      this.initData();
    },

    onBeforeDateClick() {
      const d = new Date(this.datePickerValue);
      if (this.mark === 1) this.datePickerValue = new Date(d.setDate(d.getDate() - 1));
      else if (this.mark === 2) this.datePickerValue = new Date(d.setMonth(d.getMonth() - 1, 1));
      this.setNextDateClassName();
      this.initData();
    },

    onNextDateClick() {
      if (this.nextDateClassName === 'usable') {
        const d = new Date(this.datePickerValue);
        if (this.mark === 1) this.datePickerValue = new Date(d.setDate(d.getDate() + 1));
        else if (this.mark === 2) this.datePickerValue = new Date(d.setMonth(d.getMonth() + 1, 1));
        this.setNextDateClassName();
        this.initData();
      }
    },

    setNextDateClassName() {
      const now_ymd = formatDate(new Date());
      const value_ymd = formatDate(this.datePickerValue);
      const now_ym = formatDateYm(new Date());
      const value_ym = formatDateYm(this.datePickerValue);
      if (this.mark === 1) this.nextDateClassName = now_ymd === value_ymd ? 'unusable' : 'usable';
      if (this.mark === 2) this.nextDateClassName = now_ym === value_ym ? 'unusable' : 'usable';
    },
  },

  filters: {
    shortText(val) {
      if (val.length > 12) return val.substring(0, 12) + '…';
      return val;
    },
  },
};
</script>
